import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
});

export const projectsApi = {
  list: (params) => axios.get(`${API}/ops/projects`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/projects/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/projects`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/projects/${id}`, data, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/projects/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/projects/${id}/restore`, {}, authHeaders()),
  delete: (id) => axios.delete(`${API}/ops/projects/${id}`, authHeaders()),
  trashList: () => axios.get(`${API}/ops/projects/trash/list`, authHeaders()),
  trashRestore: (trashId) => axios.post(`${API}/ops/projects/trash/${trashId}/restore`, {}, authHeaders()),
  trashPurge: (trashId) => axios.delete(`${API}/ops/projects/trash/${trashId}/purge`, authHeaders()),
};

export const employeesApi = {
  list: (params) => axios.get(`${API}/ops/employees`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/employees/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/employees`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/employees/${id}`, data, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/employees/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/employees/${id}/restore`, {}, authHeaders()),
};

export const subcontractorsApi = {
  list: (params) => axios.get(`${API}/ops/subcontractors`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/subcontractors/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/subcontractors`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/subcontractors/${id}`, data, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/subcontractors/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/subcontractors/${id}/restore`, {}, authHeaders()),
};

export const peopleApi = {
  assignees: () => axios.get(`${API}/ops/people/assignees`, authHeaders()),
};

export const assignmentsApi = {
  list: (params) => axios.get(`${API}/ops/assignments`, { ...authHeaders(), params }),
  create: (data) => axios.post(`${API}/ops/assignments`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/assignments/${id}`, data, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/assignments/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/assignments/${id}/restore`, {}, authHeaders()),
};

export const expensesApi = {
  list: (params) => axios.get(`${API}/ops/expenses`, { ...authHeaders(), params }),
  summary: (params) => axios.get(`${API}/ops/expenses/summary`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/expenses/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/expenses`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/expenses/${id}`, data, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/expenses/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/expenses/${id}/restore`, {}, authHeaders()),
};

export const receiptsApi = {
  list: (params) => axios.get(`${API}/ops/receipts`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/receipts/${id}`, authHeaders()),
  upload: (formData) => axios.post(`${API}/ops/receipts/upload`, formData, authHeaders()),
  fileBlob: (id) =>
    axios.get(`${API}/ops/receipts/${id}/file`, { ...authHeaders(), responseType: 'blob' }),
  update: (id, data) => axios.patch(`${API}/ops/receipts/${id}`, data, authHeaders()),
  delete: (id) => axios.delete(`${API}/ops/receipts/${id}`, authHeaders()),
};

export const projectFilesApi = {
  list: (params) => axios.get(`${API}/ops/project-files`, { ...authHeaders(), params }),
  upload: (formData) => axios.post(`${API}/ops/project-files/upload`, formData, authHeaders()),
  fileBlob: (id) =>
    axios.get(`${API}/ops/project-files/${id}/file`, { ...authHeaders(), responseType: 'blob' }),
  update: (id, data) => axios.patch(`${API}/ops/project-files/${id}`, data, authHeaders()),
  delete: (id) => axios.delete(`${API}/ops/project-files/${id}`, authHeaders()),
};

export const timeEntriesApi = {
  list: (params) => axios.get(`${API}/ops/time-entries`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/time-entries/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/time-entries`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/time-entries/${id}`, data, authHeaders()),
  approve: (id) => axios.post(`${API}/ops/time-entries/${id}/approve`, {}, authHeaders()),
  reopen: (id) => axios.post(`${API}/ops/time-entries/${id}/reopen`, {}, authHeaders()),
  void: (id, reason) => axios.post(`${API}/ops/time-entries/${id}/void`, { void_reason: reason || null }, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/time-entries/${id}/restore`, {}, authHeaders()),
};

export const laborApi = {
  summary: (params) => axios.get(`${API}/ops/labor/summary`, { ...authHeaders(), params }),
  projectBreakdown: (projectId) =>
    axios.get(`${API}/ops/labor/project-breakdown`, { ...authHeaders(), params: { project_id: projectId } }),
};

export const employeePaymentsApi = {
  list: (params) => axios.get(`${API}/ops/employee-payments`, { ...authHeaders(), params }),
  create: (data) => axios.post(`${API}/ops/employee-payments`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/employee-payments/${id}`, data, authHeaders()),
  void: (id, reason) => axios.post(`${API}/ops/employee-payments/${id}/void`, { void_reason: reason || null }, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/employee-payments/${id}/restore`, {}, authHeaders()),
};

export const legacyLaborPayApi = {
  summary: (params) => axios.get(`${API}/ops/employee-pay/summary`, { ...authHeaders(), params }),
  byEmployee: () => axios.get(`${API}/ops/employee-pay/by-employee`, authHeaders()),
};

export const subCommitmentsApi = {
  list: (params) => axios.get(`${API}/ops/subcontractor-commitments`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/subcontractor-commitments/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/subcontractor-commitments`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/subcontractor-commitments/${id}`, data, authHeaders()),
  approve: (id) => axios.post(`${API}/ops/subcontractor-commitments/${id}/approve`, {}, authHeaders()),
  reopen: (id) => axios.post(`${API}/ops/subcontractor-commitments/${id}/reopen`, {}, authHeaders()),
  complete: (id) => axios.post(`${API}/ops/subcontractor-commitments/${id}/complete`, {}, authHeaders()),
  cancel: (id, reason) => axios.post(`${API}/ops/subcontractor-commitments/${id}/cancel`, { cancel_reason: reason || null }, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/subcontractor-commitments/${id}/restore`, {}, authHeaders()),
};

export const subPaymentsApi = {
  list: (params) => axios.get(`${API}/ops/subcontractor-payments`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/subcontractor-payments/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/subcontractor-payments`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/subcontractor-payments/${id}`, data, authHeaders()),
  void: (id, reason) => axios.post(`${API}/ops/subcontractor-payments/${id}/void`, { void_reason: reason || null }, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/subcontractor-payments/${id}/restore`, {}, authHeaders()),
};

export const subFinancialsApi = {
  summary: (params) => axios.get(`${API}/ops/subcontractor-financials/summary`, { ...authHeaders(), params }),
  balances: (params) => axios.get(`${API}/ops/subcontractor-financials/balances`, { ...authHeaders(), params }),
};

export const projectFinancialsApi = {
  list: (params) => axios.get(`${API}/ops/project-financials`, { ...authHeaders(), params }),
  get: (projectId) => axios.get(`${API}/ops/project-financials/${projectId}`, authHeaders()),
  completedSummary: () => axios.get(`${API}/ops/project-financials/completed-summary`, authHeaders()),
};

export const priceBookItemsApi = {
  list: (params) => axios.get(`${API}/ops/price-book/items`, { ...authHeaders(), params }),
  categories: () => axios.get(`${API}/ops/price-book/items/categories`, authHeaders()),
  get: (id) => axios.get(`${API}/ops/price-book/items/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/price-book/items`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/price-book/items/${id}`, data, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/price-book/items/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/price-book/items/${id}/restore`, {}, authHeaders()),
  delete: (id) => axios.delete(`${API}/ops/price-book/items/${id}`, authHeaders()),
};

export const priceBookAssembliesApi = {
  list: (params) => axios.get(`${API}/ops/price-book/assemblies`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/price-book/assemblies/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/price-book/assemblies`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/price-book/assemblies/${id}`, data, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/price-book/assemblies/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/price-book/assemblies/${id}/restore`, {}, authHeaders()),
};

export const pbCategoriesApi = {
  list: () => axios.get(`${API}/ops/price-book/categories`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/price-book/categories`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/price-book/categories/${id}`, data, authHeaders()),
  delete: (id) => axios.delete(`${API}/ops/price-book/categories/${id}`, authHeaders()),
  reorder: (orderedIds) => axios.post(`${API}/ops/price-book/categories/reorder`, { ordered_ids: orderedIds }, authHeaders()),
};

export const leadsApi = {
  list: () => axios.get(`${API}/ops/leads`, authHeaders()),
  unreadCount: () => axios.get(`${API}/ops/leads/unread-count`, authHeaders()),
  markViewed: (id) => axios.post(`${API}/ops/leads/${id}/view`, {}, authHeaders()),
  convert: (id) => axios.post(`${API}/ops/leads/${id}/convert-to-quote`, {}, authHeaders()),
  delete: (id) => axios.delete(`${API}/ops/leads/${id}`, authHeaders()),
};

export const employeePayApi = {
  createInvite: (payload) => axios.post(`${API}/ops/employee-pay/invites`, payload, authHeaders()),
  listInvites: () => axios.get(`${API}/ops/employee-pay/invites`, authHeaders()),
  revokeInvite: (token) => axios.delete(`${API}/ops/employee-pay/invites/${token}`, authHeaders()),
  employees: () => axios.get(`${API}/ops/employee-pay/employees`, authHeaders()),
  employee: (id) => axios.get(`${API}/ops/employee-pay/employees/${id}`, authHeaders()),
  update: (id, payload) => axios.patch(`${API}/ops/employee-pay/employees/${id}`, payload, authHeaders()),
  remove: (id) => axios.delete(`${API}/ops/employee-pay/employees/${id}`, authHeaders()),
  resetLink: (id) => axios.post(`${API}/ops/employee-pay/employees/${id}/reset-link`, {}, authHeaders()),
  clockIn: (id) => axios.post(`${API}/ops/employee-pay/employees/${id}/clock-in`, {}, authHeaders()),
  clockOut: (id) => axios.post(`${API}/ops/employee-pay/employees/${id}/clock-out`, {}, authHeaders()),
  entries: (id) => axios.get(`${API}/ops/employee-pay/employees/${id}/entries`, authHeaders()),
  editEntry: (entryId, payload) => axios.patch(`${API}/ops/employee-pay/entries/${entryId}`, payload, authHeaders()),
  voidEntry: (entryId, reason) => axios.post(`${API}/ops/employee-pay/entries/${entryId}/void`, { reason }, authHeaders()),
  weeks: (id) => axios.get(`${API}/ops/employee-pay/employees/${id}/weeks`, authHeaders()),
  issueStub: (id, week_start) => axios.post(`${API}/ops/employee-pay/employees/${id}/pay-stubs`, { week_start }, authHeaders()),
  stubs: (id) => axios.get(`${API}/ops/employee-pay/employees/${id}/pay-stubs`, authHeaders()),
};

export const quotesApi = {
  list: (params) => axios.get(`${API}/ops/quotes`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/quotes/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/quotes`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/quotes/${id}`, data, authHeaders()),
  publish: (id) => axios.post(`${API}/ops/quotes/${id}/publish`, {}, authHeaders()),
  accept: (id) => axios.post(`${API}/ops/quotes/${id}/accept`, {}, authHeaders()),
  decline: (id, reason) => axios.post(`${API}/ops/quotes/${id}/decline`, { decline_reason: reason || null }, authHeaders()),
  cancel: (id, reason) => axios.post(`${API}/ops/quotes/${id}/cancel`, { cancel_reason: reason || null }, authHeaders()),
  reopen: (id) => axios.post(`${API}/ops/quotes/${id}/reopen`, {}, authHeaders()),
  setDiscount: (id, discount_percent) => axios.post(`${API}/ops/quotes/${id}/discount`, { discount_percent }, authHeaders()),
  preview: (id) => axios.get(`${API}/ops/quotes/${id}/preview`, authHeaders()),
  delete: (id) => axios.delete(`${API}/ops/quotes/${id}`, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/quotes/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/quotes/${id}/restore`, {}, authHeaders()),
  publicLink: (id) => axios.get(`${API}/ops/quotes/${id}/public-link`, authHeaders()),
  enableLink: (id) => axios.post(`${API}/ops/quotes/${id}/public-link/enable`, {}, authHeaders()),
  disableLink: (id) => axios.post(`${API}/ops/quotes/${id}/public-link/disable`, {}, authHeaders()),
  rotateLink: (id) => axios.post(`${API}/ops/quotes/${id}/public-link/rotate`, {}, authHeaders()),
  convertToProject: (id, data) => axios.post(`${API}/ops/quotes/${id}/convert-to-project`, data, authHeaders()),
};

export const quoteLinesApi = {
  list: (quoteId, params) => axios.get(`${API}/ops/quotes/${quoteId}/lines`, { ...authHeaders(), params }),
  createCustom: (quoteId, data) => axios.post(`${API}/ops/quotes/${quoteId}/lines`, data, authHeaders()),
  fromPriceBook: (quoteId, data) => axios.post(`${API}/ops/quotes/${quoteId}/lines/from-price-book`, data, authHeaders()),
  fromAssembly: (quoteId, data) => axios.post(`${API}/ops/quotes/${quoteId}/lines/from-assembly`, data, authHeaders()),
  update: (quoteId, lineId, data) => axios.patch(`${API}/ops/quotes/${quoteId}/lines/${lineId}`, data, authHeaders()),
  remove: (quoteId, lineId) => axios.post(`${API}/ops/quotes/${quoteId}/lines/${lineId}/remove`, {}, authHeaders()),
  restore: (quoteId, lineId) => axios.post(`${API}/ops/quotes/${quoteId}/lines/${lineId}/restore`, {}, authHeaders()),
  reorder: (quoteId, lineIds) => axios.post(`${API}/ops/quotes/${quoteId}/lines/reorder`, { line_ids: lineIds }, authHeaders()),
};

// Public customer quote API — token-authorized, NO admin headers
export const publicQuotesApi = {
  get: (token) => axios.get(`${API}/public/quotes/${token}`),
  viewed: (token) => axios.post(`${API}/public/quotes/${token}/viewed`),
  approve: (token, data) => axios.post(`${API}/public/quotes/${token}/approve`, data),
  decline: (token, data) => axios.post(`${API}/public/quotes/${token}/decline`, data),
};

export const changeOrdersApi = {
  list: (params) => axios.get(`${API}/ops/customer-change-orders`, { ...authHeaders(), params }),
  get: (id) => axios.get(`${API}/ops/customer-change-orders/${id}`, authHeaders()),
  create: (data) => axios.post(`${API}/ops/customer-change-orders`, data, authHeaders()),
  update: (id, data) => axios.patch(`${API}/ops/customer-change-orders/${id}`, data, authHeaders()),
  publish: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/publish`, {}, authHeaders()),
  approve: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/approve`, {}, authHeaders()),
  decline: (id, reason) => axios.post(`${API}/ops/customer-change-orders/${id}/decline`, { decline_reason: reason || null }, authHeaders()),
  cancel: (id, reason) => axios.post(`${API}/ops/customer-change-orders/${id}/cancel`, { cancel_reason: reason || null }, authHeaders()),
  reopen: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/reopen`, {}, authHeaders()),
  archive: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/archive`, {}, authHeaders()),
  restore: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/restore`, {}, authHeaders()),
  publicLink: (id) => axios.get(`${API}/ops/customer-change-orders/${id}/public-link`, authHeaders()),
  enableLink: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/public-link/enable`, {}, authHeaders()),
  disableLink: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/public-link/disable`, {}, authHeaders()),
  rotateLink: (id) => axios.post(`${API}/ops/customer-change-orders/${id}/public-link/rotate`, {}, authHeaders()),
  lines: (id, params) => axios.get(`${API}/ops/customer-change-orders/${id}/lines`, { ...authHeaders(), params }),
  createCustomLine: (id, data) => axios.post(`${API}/ops/customer-change-orders/${id}/lines`, data, authHeaders()),
  fromPriceBook: (id, data) => axios.post(`${API}/ops/customer-change-orders/${id}/lines/from-price-book`, data, authHeaders()),
  fromAssembly: (id, data) => axios.post(`${API}/ops/customer-change-orders/${id}/lines/from-assembly`, data, authHeaders()),
  updateLine: (id, lineId, data) => axios.patch(`${API}/ops/customer-change-orders/${id}/lines/${lineId}`, data, authHeaders()),
  removeLine: (id, lineId) => axios.post(`${API}/ops/customer-change-orders/${id}/lines/${lineId}/remove`, {}, authHeaders()),
  restoreLine: (id, lineId) => axios.post(`${API}/ops/customer-change-orders/${id}/lines/${lineId}/restore`, {}, authHeaders()),
  reorderLines: (id, lineIds) => axios.post(`${API}/ops/customer-change-orders/${id}/lines-reorder`, { line_ids: lineIds }, authHeaders()),
};

export const publicChangeOrdersApi = {
  get: (token) => axios.get(`${API}/public/change-orders/${token}`),
  viewed: (token) => axios.post(`${API}/public/change-orders/${token}/viewed`),
  approve: (token, data) => axios.post(`${API}/public/change-orders/${token}/approve`, data),
  decline: (token, data) => axios.post(`${API}/public/change-orders/${token}/decline`, data),
};

export const closeoutsApi = {
  get: (projectId) => axios.get(`${API}/ops/project-closeouts/${projectId}`, authHeaders()),
  readiness: (projectId) => axios.get(`${API}/ops/project-closeouts/${projectId}/readiness`, authHeaders()),
  close: (projectId, data) => axios.post(`${API}/ops/project-closeouts/${projectId}/close`, data, authHeaders()),
  reopen: (projectId, reason) => axios.post(`${API}/ops/project-closeouts/${projectId}/reopen`, { reopen_reason: reason }, authHeaders()),
};

export const reportsApi = {
  executiveSummary: () => axios.get(`${API}/ops/reports/executive-summary`, authHeaders()),
  profitability: (params) => axios.get(`${API}/ops/reports/project-profitability`, { ...authHeaders(), params }),
  estimateVsActual: (params) => axios.get(`${API}/ops/reports/estimate-vs-actual`, { ...authHeaders(), params }),
  revenueChanges: (params) => axios.get(`${API}/ops/reports/revenue-changes`, { ...authHeaders(), params }),
  costMix: (params) => axios.get(`${API}/ops/reports/cost-mix`, { ...authHeaders(), params }),
  customerResponses: (params) => axios.get(`${API}/ops/reports/customer-response-pipeline`, { ...authHeaders(), params }),
  closeoutLessons: (params) => axios.get(`${API}/ops/reports/closeout-lessons`, { ...authHeaders(), params }),
};

export const calendarApi = {
  feed: (params) => axios.get(`${API}/ops/calendar/items`, { ...authHeaders(), params }),
  listEvents: (params) => axios.get(`${API}/ops/calendar-events`, { ...authHeaders(), params }),
  getEvent: (id) => axios.get(`${API}/ops/calendar-events/${id}`, authHeaders()),
  createEvent: (data) => axios.post(`${API}/ops/calendar-events`, data, authHeaders()),
  updateEvent: (id, data) => axios.patch(`${API}/ops/calendar-events/${id}`, data, authHeaders()),
  archiveEvent: (id) => axios.post(`${API}/ops/calendar-events/${id}/archive`, {}, authHeaders()),
  restoreEvent: (id) => axios.post(`${API}/ops/calendar-events/${id}/restore`, {}, authHeaders()),
};

export const aiApi = {
  quoteWriter: (data) => axios.post(`${API}/ops/ai/quote-writer`, data, authHeaders()),
  chat: (session_id, message) => axios.post(`${API}/ops/ai/chat`, { session_id, message }, { ...authHeaders(), timeout: 120000 }),
  confirm: (session_id, action, approved = true) => axios.post(`${API}/ops/ai/confirm`, { session_id, action, approved }, { ...authHeaders(), timeout: 60000 }),
  sessions: () => axios.get(`${API}/ops/ai/chat/sessions`, authHeaders()),
  messages: (sid) => axios.get(`${API}/ops/ai/chat/${sid}/messages`, authHeaders()),
};
